import { render, staticRenderFns } from "./MedicalInstitutionsStatistics.vue?vue&type=template&id=12496e55&"
import script from "./MedicalInstitutionsStatistics.vue?vue&type=script&lang=js&"
export * from "./MedicalInstitutionsStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports